import * as React from 'react'
import { Link, LINK_APPEARANCE_INLINE, SIZE_SMALL } from '@mds/mds-reactjs-library'
import styled from 'styled-components'

const Wrapper = styled.footer`
  display: block;
  width: 100%;
  padding: 24px 2rem 2rem 2rem;
  margin: 0 1rem 1rem 1rem;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #999;
  text-shadow: ${
    /* istanbul ignore next */
    (props) => props.theme.footerTextShadow
  };

  .mds-block-link span span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-decoration: underline;
  }
`

const bemComponentName = 'footer'

const needHelp = `${bemComponentName}__needHelp`
const privacyPolicy = `${bemComponentName}__privacyPolicy`
const link = `${bemComponentName}__link`

type FooterProps = {
  version: string
}

function Footer({ version }: FooterProps) {
  return (
    <Wrapper>
      <footer>
        <section className={needHelp}>
          <Link className={link} appearance={LINK_APPEARANCE_INLINE} size={SIZE_SMALL} href="/help">
            Need help?
          </Link>
        </section>
        <section className={privacyPolicy}>
          <Link
            className={link}
            appearance={LINK_APPEARANCE_INLINE}
            size={SIZE_SMALL}
            href="https://www.mckinsey.com/solutions-privacy-statement"
          >
            Access our Privacy Policy
          </Link>
        </section>
        <section>{version}</section>
      </footer>
    </Wrapper>
  )
}

export default Footer
